import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark' | 'system';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

function applyTheme(theme: Theme) {
  const root = document.documentElement;
  const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  root.classList.toggle('dark', isDark);

  if (isDark) {
    root.style.setProperty('--card-bg',        '#1e293b');
    root.style.setProperty('--card-border',    '#334155');
    root.style.setProperty('--page-bg',        '#0f172a');
    root.style.setProperty('--surface-subtle', '#0f172a');
    root.style.setProperty('--surface-muted',  '#1e293b');
    root.style.setProperty('--text-primary',   '#e2e8f0');
    root.style.setProperty('--text-secondary', '#94a3b8');
    root.style.setProperty('--border-color',   '#334155');
    root.style.setProperty('--input-bg',       '#0f172a');
  } else {
    root.style.setProperty('--card-bg',        '#ffffff');
    root.style.setProperty('--card-border',    '#e2e8f0');
    root.style.setProperty('--page-bg',        '#f8fafc');
    root.style.setProperty('--surface-subtle', '#f8fafc');
    root.style.setProperty('--surface-muted',  '#f1f5f9');
    root.style.setProperty('--text-primary',   '#1e293b');
    root.style.setProperty('--text-secondary', '#64748b');
    root.style.setProperty('--border-color',   '#e2e8f0');
    root.style.setProperty('--input-bg',       '#ffffff');
  }
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
    }),
    { name: 'lms-theme' }
  )
);

export { applyTheme };
